import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  ComponentAdditionPageContext,
  ComponentAdditionPageInitialState,
} from ".";

export const ComponentAdditionPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(ComponentAdditionPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ComponentAdditionPageContext.Provider value={context}>
      {children}
    </ComponentAdditionPageContext.Provider>
  );
};
